import React, { forwardRef, Children } from 'react';
import styled from 'styled-components';
import { TabListItemStyle } from './Tabs.styles.js';

const TabIcon = ({ icon, role }) => {
    if (icon) {
        const [IconComponent, iconProps] = Array.isArray(icon)
            ? icon
            : 'props' in icon
                ? [icon.type, icon.props]
                : [icon];
        return (React.createElement(IconComponent, { className: "tab-icon", role: role, ...iconProps }));
    }
    return null;
};
const TabButton = forwardRef(({ alignment, // Used only in styling, prevent passing it to DOM
children, color, // Used only in styling, prevent passing it to DOM
icon, iconPos, // Used only in styling, prevent passing it to DOM
selected = false, sizing, // Used only in styling, prevent passing it to DOM
variant, // Used only in styling, prevent passing it to DOM
...rest }, ref) => {
    const tabIndex = selected
        ? // As tab list items are <button> elements, the selected tab is
            // in the keyboard Tab sequence by default without a tabIndex.
            undefined
        : // Unselected tabs are removed from the keyboard Tab sequence.
            -1;
    // Icon is presentational, if tab has a readable label
    const iconRole = Children.count(children) > 0 ||
        'aria-label' in rest ||
        'aria-labelledby' in rest
        ? 'presentation'
        : undefined;
    return (React.createElement("button", { ...rest, "aria-selected": selected, role: "tab", tabIndex: tabIndex, type: "button", ref: ref },
        React.createElement(TabIcon, { icon: icon, role: iconRole }),
        React.createElement("span", { className: "tab-label" }, children)));
});
TabButton.displayName = 'TabButton';
/**
 * `<TabListIten>` is used internally to render an individual tab control.
 *
 * @internal
 */
const TabListItem = styled(TabButton).attrs(({ children, icon }) => ({
    $iconOnly: !!icon && Children.count(children) === 0,
})) `
    ${TabListItemStyle}
`;

export { TabListItem };
//# sourceMappingURL=TabListItem.js.map
